import Event from '../Event';

export default class NotificationConsumed extends Event {
    public static type = 'NotificationConsumed';

    constructor(public readonly id: string) {
        super(NotificationConsumed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/core/events/NotificationConsumed.ts